import React from 'react';
import { useOnboardingStore } from '@features/onboarding/store/onboarding';

interface ExcuseStepProps {
  hideTitle?: boolean;
}

export const ExcuseStep: React.FC<ExcuseStepProps> = ({
  hideTitle = false,
}) => {
  const { data } = useOnboardingStore();

  return (
    <div className="p-4 pr-17 md:py-8 md:px-10">
      {!hideTitle && (
        <h3 className="text-4xl font-extrabold mb-8">Your options.</h3>
      )}
      {/* text-[15px] mb-2 !font-secondary leading-5 tracking-tight max-w-190 */}
      <p className="text-[15px] leading-6 flex flex-col px-7 py-6 bg-[#f4f3f3] w-fit rounded-2xl">
        <strong className="text-2xl text-[17px]">
          About Health Insurance – Let's Find Your Best Fit!
        </strong>
        <span>
          While we couldn't approve your health plan this time based on your
          questionnaire responses, there's still plenty of good news!
          <br />
          You may qualify for an ACA plan and see instant quotes with just one
          click.
          <br />
          Plus, any ancillary plans you selected — like dental, vision, or other
          coverage — are fully approved and ready for you to lock in today.
          <br />
          Your next steps:
          <br />
          <strong className="text-primary">See ACA Plan Options</strong> – Check
          out other health plans with instant quotes.
          <br />
          <strong className="text-primary">
            Explore Extra Protection Plans
          </strong>{' '}
          – We also offer plans that can help with expenses if you're
          hospitalized, have an accident, or are diagnosed with a critical
          illness. It's a smart way to make sure you've got some level of
          coverage in place.
        </span>
      </p>
    </div>
  );
};
